import { useEffect } from "react";
import { applyCompanyTheme, isValidHexColor } from "../../theme/companyTheme";

/**
 * Temporarily applies draft theme colors to the live page while editing.
 * Does not persist — parent restores saved theme on cancel.
 */
export default function DraftThemeApplicator({
  enabled,
  primaryColor,
  secondaryColor,
}) {
  useEffect(() => {
    if (!enabled) return;
    if (isValidHexColor(primaryColor) && isValidHexColor(secondaryColor)) {
      applyCompanyTheme({ primary: primaryColor, secondary: secondaryColor });
    }
  }, [enabled, primaryColor, secondaryColor]);

  return null;
}
